function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import i18n, { changeLocale } from '@/utils/i18n';
import emitter from '@/utils/emitter';
import { COMMON_PROPERTIES$1, ADVANCED_PROPERTIES$1, EVENT_PROPERTIES$1 } from '../configData';
import CodeEditor from '@/components/code-editor/index';
import FormSetting from '@/components/form-designer/setting-panel/form-setting.vue';
import { propertyRegistered } from '../../utils';
import { addWindowResizeHandler } from '@/utils/util';
import comp from '../property-editor/export';
import PropertyEditors from '@/components/form-designer/setting-panel/property-editor/index';
export default {
  name: 'SettingPanel',
  componentName: 'SettingPanel',
  mixins: [i18n, emitter],
  components: _objectSpread(_objectSpread({
    CodeEditor: CodeEditor,
    FormSetting: FormSetting
  }, PropertyEditors), comp),
  props: {
    designer: Object,
    selectedWidget: Object,
    formConfig: Object,
    globalDsv: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  provide: function provide() {
    var _this = this;
    return {
      isSubFormChildWidget: function isSubFormChildWidget() {
        return _this.subFormChildWidgetFlag;
      },
      getGlobalDsv: function getGlobalDsv() {
        return _this.globalDsv;
      }
    };
  },
  inject: ['getDesignerConfig'],
  data: function data() {
    return {
      designerConfig: this.getDesignerConfig(),
      activeTab: '2',
      widgetActiveCollapseNames: ['1', '3'],
      formActiveCollapseNames: ['1', '2'],
      commonProps: COMMON_PROPERTIES$1,
      advProps: ADVANCED_PROPERTIES$1,
      eventProps: EVENT_PROPERTIES$1,
      showWidgetEventDialogFlag: !1,
      eventHandlerCode: '',
      curEventName: '',
      eventHeader: '',
      subFormChildWidgetFlag: !1,
      scrollerHeight: 0
    };
  },
  computed: {
    optionModel: {
      get: function get() {
        return this.selectedWidget.options;
      },
      set: function set(o) {
        this.selectedWidget.options = o;
      }
    }
  },
  watch: {
    'designer.selectedWidget': {
      handler: function handler(o) {
        o && (this.activeTab = '1');
      }
    },
    'selectedWidget.options': {
      deep: !0,
      handler: function handler() {
        this.designer.saveCurrentHistoryStep();
      }
    },
    formConfig: {
      deep: !0,
      handler: function handler() {
        this.designer.saveCurrentHistoryStep();
      }
    }
  },
  created: function created() {
    var _this2 = this;
    this.on$('editEventHandler', function (o) {
      _this2.editEventHandler(o[0], o[1]);
    }), this.designer.handleEvent('form-css-updated', function (o) {
      _this2.designer.setCssClassList(o);
    }), this.designer.handleEvent('field-selected', function (o) {
      _this2.subFormChildWidgetFlag = !!o && o.type === 'sub-form';
    });
  },
  mounted: function mounted() {
    var _this3 = this;
    this.designer.selectedWidget ? this.activeTab = '1' : this.activeTab = '2';
    this.scrollerHeight = window.innerHeight - 54 + 'px';
    addWindowResizeHandler(function () {
      _this3.$nextTick(function () {
        _this3.scrollerHeight = window.innerHeight - 54 + 'px';
      });
    });
  },
  methods: {
    optionModelChange: function optionModelChange(o) {
      this.optionModel = o;
    },
    clearSearch: function clearSearch(o) {
      o.setDimensional = {
        dimension: [],
        metrics: [],
        targetValue: 1,
        showFields: [],
        dimensionRow: [],
        dimensionCol: []
      };
      o.setChartFilter = {
        equation: '',
        list: []
      };
      this.optionModel = o;
    },
    getEventHandled: function getEventHandled(o) {
      return !!this.optionModel[o] && this.optionModel[o].length > 0;
    },
    showEventCollapse: function showEventCollapse() {
      return this.designerConfig.eventCollapse === void 0 ? !0 : !!this.designerConfig.eventCollapse;
    },
    hasPropEditor: function hasPropEditor(o, e) {
      if (!e) return !1;
      var type = false;
      for (var n in this.selectedWidget.options) {
        var name = e.split('-')[0];
        if (name === n) {
          type = true;
        }
      }
      return type;
    },
    getPropEditor: function getPropEditor(o, e) {
      for (var n in this.selectedWidget.options) {
        var name = e.split('-')[0];
        if (name === n) {
          return this.$options.components[e];
        }
      }
    },
    showCollapse: function showCollapse(o) {
      var e = !1;
      for (var n in o) if (!!o.hasOwnProperty(n) && this.hasPropEditor(n, o[n])) {
        e = !0;
        break;
      }
      return e;
    },
    editEventHandler: function editEventHandler(o, e) {
      ;
      this.curEventName = o, this.eventHeader = "".concat(this.optionModel.name, ".").concat(o, "(").concat(e.join(', '), ") {"), this.eventHandlerCode = this.selectedWidget.options[o] || '', o === 'onValidate' && !this.optionModel.onValidate && (this.eventHandlerCode = "  /* sample code */\n  /*\n  if ((value > 100) || (value < 0)) {\n    callback(new Error('error message'))  //fail\n  } else {\n    callback();  //pass\n  }\n  */"), this.showWidgetEventDialogFlag = !0;
    },
    saveEventHandler: function saveEventHandler() {
      var _this4 = this;
      var o = this.$refs.ecEditor.getEditorAnnotations();
      var e = !1;
      if (!!o && o.length > 0 && (o.forEach(function (n) {
        n.type === 'error' && (e = !0);
      }), e)) {
        this.$confirm(this.i18nt('designer.setting.syntaxCheckWarning'), this.i18nt('render.hint.prompt'), {
          confirmButtonText: this.i18nt('render.hint.forcedSave'),
          cancelButtonText: this.i18nt('render.hint.cancel')
        }).then(function () {
          ;
          _this4.selectedWidget.options[_this4.curEventName] = _this4.eventHandlerCode, _this4.showWidgetEventDialogFlag = !1;
        }).catch(function (n) {});
        return;
      }
      ;
      this.selectedWidget.options[this.curEventName] = this.eventHandlerCode, this.showWidgetEventDialogFlag = !1;
    }
  }
};